export default __webpack_public_path__ + "static/media/icon_transparent.5779a96f.png";